import type { FieldError } from "react-hook-form";

/** Returns the field error message only when the screen should show it. */
export function getVisibleError(
  error: FieldError | undefined,
  showError: boolean,
): string | undefined {
  return showError ? error?.message : undefined;
}
